export const enAgentGuiComposer = {
  loadingOptions: "Loading…",
  composerOptionsLoadFailed: "Configuration failed to load",
  composerOptionsRetry: "Retry",
  composerOptionsRetryTooltip:
    "Unable to load shared Agent information. Click to retry",
  sendFailed: "The message could not be sent.",
  returnToConversation: "Back to conversation",
  continueAnswering: "Continue answering",
  inheritedUnavailable: "Inherited / unavailable",
  modelConsumptionSpeedLabel: "Consumption rate",
  modelConsumptionMultiplierSuffix: "multiplier"
};
